<div class="row contrast-container product-detail" *ngIf="concept != null; else loading">
  <div class="col-xs-12 col-sm-6">
    @if(concept){
      <lib-product-details-image-carousel
        [openExternal]="false"
        [zoom]="false"
        [images]="concept.extra.images"
        imageSize="500x500"
        [highRes]="true"
        [imageColorFill]="''"
      />
    }

  </div>
  <div class="col-xs-12 col-sm-6">
    <h1>{{ concept.name }} - {{ concept.id }}</h1>
    <p [innerHTML]="(concept.extra?.i18n?.[currentLang]?.description || concept.extra?.pim?.description || concept.description || '') | safeHtml"></p>
    @if(concept.extra?.i18n?.[currentLang]?.descriptionHTML || concept.extra?.pim?.descriptionHTML){
      <div [innerHTML]="(concept.extra?.i18n?.[currentLang]?.descriptionHTML || concept.extra?.pim?.descriptionHTML) | safeHtml"></div>
    }

    @if (hasPimPropertiesToShow && hasPimGroupsToShow) {
      <lib-gung-accordion-pim-data-templates [product]="concept"/>
    }


    @if(!!concept?.extra?.pim?.configurationTemplate){
      <lib-cpq-configurator-inline
        [productId]="concept?.extra?.pim?.configurationTemplate"
        [configurationOutputProductId]="concept?.extra?.pim?.configurationOutputProductId"
      ></lib-cpq-configurator-inline>
    }

  </div>
</div>

<ng-template #cloudPimFields>
  <lib-cloud-pim-product-fields [product]="concept"></lib-cloud-pim-product-fields>
</ng-template>
<ng-template #nan></ng-template>
<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</ng-template>
